import React from 'react';
import { Breadcrumbs } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { useCompanyData } from '../../shared/contexts/DataContext';
import { Link , useParams } from 'react-router-dom';

const useStyles = makeStyles(() => ({
    breadWhite:{
      color:'#fff',
      fontSize:'1.3rem'
    },

    separator:{
      color: '#FAC400'
    },

    breadOl:{
      justifyContent:'center'
    },
}));

const CustomBreadCrumbs = ({title}) =>{
    const { data } = useCompanyData();
    const { id } = useParams();
    const { t, companyDomain } = data;
    const classes = useStyles();
    return(
      <Breadcrumbs separator="•" aria-label="breadcrumb" style={{fontFamily:'inherit'}} classes={{separator:classes.separator,li:classes.breadWhite,ol:classes.breadOl}}>
          <Link to={companyDomain ? '/' : `/${id}`}>
          {t && t('companyPage.home')}
          </Link>
          <span style={{ color: '#FAC400',textTransform:'capitalize' }}>
          {title}
          </span>
      </Breadcrumbs>
    )
};

export default CustomBreadCrumbs;
